// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"f56005ba","503":"f56005ba","952":"27bed7ae","996":"5f62846c"}[chunkId] + ".chunk.css";
};